/**
 * jQuery Global Setup
 * This file MUST be imported BEFORE materialize-css/dist/js/materialize.min.js
 *
 * Materialize v1.0.0 checks for window.jQuery at load time to register
 * jQuery plugins ($.fn.modal, $.fn.dropdown, etc.). If jQuery is not on
 * window when Materialize loads, the jQuery plugin adapter is skipped.
 *
 * ES module imports are hoisted, so we use a separate file to ensure
 * jQuery is attached to window before Materialize's import executes.
 */
import $ from "jquery";

(window as any).$ = $;
(window as any).jQuery = $;
